import React from 'react';
import './LoadingScreen.css';

export default function LoadingScreen() {
  return (
    <div className="loading-screen">
      <div className="loading-container">
        <div className="loading-logo">
          <span className="loading-logo-arc">ARC</span><span className="loading-logo-aml">aml</span>
        </div>
        <div className="loading-bar-wrapper">
          <div className="loading-bar-track">
            <div className="loading-bar-fill"></div>
          </div>
        </div>
        <p>Setting up your dashboard…</p>
      </div>
    </div>
  );
}
